export const FEE_RECIPIENT_LABELS: Record<string, { label: string; description: string }> = {
  rollops: { label: 'RollOps', description: 'Platform receives fee' },
  gym: { label: 'Business', description: 'Business receives fee' },
  stripe: { label: 'Stripe', description: 'Processor receives fee' },
};

export const CHARGE_EFFECT_LABELS: Record<string, { label: string; description: string }> = {
  none: { label: 'Absorbed', description: 'Hidden from customer' },
  add: { label: 'Added', description: 'Charged to customer' },
};

export const PAYOUT_EFFECT_LABELS: Record<string, { label: string; description: string }> = {
  credit: { label: 'Credited', description: 'Added to payout' },
  debit: { label: 'Debited', description: 'Deducted from payout' },
};

export const CALCULATION_BASIS_LABELS: Record<string, { label: string; description: string }> = {
  from_base_amount: { label: 'Base Amount', description: 'From subscription price' },
  stripe_fee: { label: 'Stripe Formula', description: 'Standard processing rate' },
  net_after_prior_fees: { label: 'Net Amount', description: 'After prior deductions' },
};

export const CONTEXT_LABELS: Record<string, string> = {
  customer_subscription: 'Customer Subscription',
  saas_subscription: 'SaaS Subscription',
};
